import AContainer from "../../library/ExtendedObjects/AContainer.js";
import Utils from "../../library/Utils.js";
import SendArea from "./SendArea.js";

export default class TextArea extends AContainer
{
    /**
     * @param {SendArea} parent 
     */
    constructor(scene, parent)
    {
        super(scene);

        this.sendArea = parent;

        this.textAreas = [];
        this.texts = [];
        let spacing = 16;

        for (let i = 0; i < 3; i++) {
            let textArea = this.scene.addImage(0, 0, "TextSelection");
            let textGroup = this.scene.add.container(0, spacing + (i * (textArea.height + spacing)) + (textArea.height * .5), textArea);
            this.texts.push(this.scene.addText(-320, 0, "", 23, {width: 650}, 0, textGroup).setOrigin(0, .5));
            this.textAreas.push(textGroup);

            textArea.setInteractive();
            textArea.on("pointerdown", ()=>{
                this.textAreaSelected(textArea, this.texts[i]);
            });
        }

        this.selectedField = null;
        this.add(this.textAreas);
    }

    populateTexts(correctText, incorrectTexts)
    {
        incorrectTexts.push(correctText);
        let options = Utils.Shuffle(incorrectTexts);
        for(let i = 0; i < this.texts.length; i++)
        {
            this.texts[i].setTextTo(options[i]);
        }
    }

    textAreaSelected(textArea, text)
    {
        this.scene.playSound("click");
        this.unselectText();
        this.selectedField = textArea;
        textArea.tint = 0xaaaaaa;
        this.sendArea.setText(text.text);
    }

    unselectText()
    {
        if(this.selectedField != null) this.selectedField.tint = 0xffffff;
    }
}